import { aboutEntry } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 bg-background-200/70">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">{aboutEntry.title}</h2>
          </div>

          <div className="space-y-5">
            {aboutEntry.paragraphs.map((p, i) => (
              <p key={i} className="text-foreground-600 text-sm md:text-base leading-relaxed">{p}</p>
            ))}
          </div>

          <div className="flex flex-wrap justify-center gap-6 mt-10 pt-8 border-t border-background-300/60">
            <div className="text-center">
              <div className="font-heading text-3xl text-primary-500">2023</div>
              <div className="text-xs text-foreground-400 mt-1">成立年份</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl text-accent-500">2000+</div>
              <div className="text-xs text-foreground-400 mt-1">高清资源</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl text-secondary-600">500万+</div>
              <div className="text-xs text-foreground-400 mt-1">忠实观众</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl text-primary-500">每日更新</div>
              <div className="text-xs text-foreground-400 mt-1">热剧同步</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}